import axiosInstance from './api';
import API_URL from '../apiconfig';

export async function getUser() {
  try {
    const user = await axiosInstance.get(`${API_URL}/v1/users/me`);

    return user.data.result;
  } catch (error) {
    throw new Error('Cannot get user');
  }
}
